import { jsx, jsxs } from "react/jsx-runtime";
import react from "react";
import { cn } from "../../utils/index.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { IconButton } from "../IconButton/index.js";
import { Span } from "../Text/index.js";
import { statusBannerVariants } from "./StatusBanner.variants.js";
const icons = {
    info: /*#__PURE__*/ jsx(CdnIcon, {
        iconName: "info"
    }),
    success: /*#__PURE__*/ jsx(CdnIcon, {
        iconName: "check_circle"
    }),
    caution: /*#__PURE__*/ jsx(CdnIcon, {
        iconName: "warning"
    }),
    error: /*#__PURE__*/ jsx(CdnIcon, {
        iconName: "error"
    })
};
function StatusBanner({ captionNode, headingNode, primaryCtaNode, secondaryCtaNode, iconNode, hideIcon = false, onDismiss, dismissAriaLabel = 'Dismiss', slots = {
    baseSlot: '',
    contentCtaSlot: '',
    iconSlot: '',
    headingSlot: '',
    captionSlot: '',
    ctaSlot: '',
    headingContentSlot: '',
    iconContentWrapper: '',
    dismissSlot: ''
}, ...props }) {
    const { baseSlot, headingSlot, captionSlot, ctaSlot, contentCtaSlot, iconSlot, headingContentSlot, iconContentWrapper, dismissSlot } = statusBannerVariants({
        ...props
    });
    const icon = hideIcon ? null : iconNode || icons[props.palette];
    const baseSlotClasses = cn(baseSlot(), '@container', slots.baseSlot);
    const contentCtaSlotClasses = cn(contentCtaSlot(), slots.contentCtaSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const headingSlotClasses = cn(headingSlot(), slots.headingSlot);
    const captionSlotClasses = cn(captionSlot(), slots.captionSlot);
    const ctaSlotClasses = cn(ctaSlot(), slots.ctaSlot);
    const headingContentSlotClasses = cn(headingContentSlot(), slots.headingContentSlot);
    const iconContentWrapperClasses = cn(iconContentWrapper(), slots.iconContentWrapper);
    const dismissSlotClasses = cn(dismissSlot(), slots.dismissSlot);
    const getCtaProps = ()=>({
            type: 'tertiary',
            emphasis: 'bold' === props.emphasis ? 'bold' : 'regular',
            className: 'bold' === props.emphasis && 'caution' === props.palette ? 'text-caution-13 hover:text-caution-13' : ''
        });
    return /*#__PURE__*/ jsxs("div", {
        className: baseSlotClasses,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: contentCtaSlotClasses,
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: iconContentWrapperClasses,
                        children: [
                            icon && /*#__PURE__*/ jsx("div", {
                                className: iconSlotClasses,
                                children: icon
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: headingContentSlotClasses,
                                children: [
                                    headingNode && /*#__PURE__*/ jsx(Span, {
                                        className: headingSlotClasses,
                                        bold: true,
                                        children: headingNode
                                    }),
                                    captionNode && /*#__PURE__*/ jsx(Span, {
                                        className: captionSlotClasses,
                                        children: captionNode
                                    })
                                ]
                            })
                        ]
                    }),
                    (!!primaryCtaNode || !!secondaryCtaNode) && /*#__PURE__*/ jsxs("div", {
                        className: ctaSlotClasses,
                        children: [
                            secondaryCtaNode && /*#__PURE__*/ react.cloneElement(secondaryCtaNode, getCtaProps()),
                            primaryCtaNode && /*#__PURE__*/ react.cloneElement(primaryCtaNode, getCtaProps())
                        ]
                    })
                ]
            }),
            onDismiss && /*#__PURE__*/ jsx("div", {
                className: dismissSlotClasses,
                children: /*#__PURE__*/ jsx(IconButton, {
                    iconName: "close",
                    type: "plainSecondary",
                    size: "sm",
                    emphasis: 'bold' === props.emphasis ? 'bold' : 'regular',
                    "aria-label": dismissAriaLabel,
                    onClick: onDismiss,
                    slots: {
                        wrapperSlot: 'bold' === props.emphasis && 'caution' === props.palette ? 'text-caution-13' : '',
                        iconSlot: 'bold' === props.emphasis && 'caution' === props.palette ? 'text-caution-13 group-hover:text-caution-13' : ''
                    }
                })
            })
        ]
    });
}
export { StatusBanner };
